import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { onUnexpectedError } from '../../../base/common/errors.js';
import { Lazy } from '../../../base/common/lazy.js';
import { Disposable, MutableDisposable } from '../../../base/common/lifecycle.js';
import { MessageController } from '../message/messageController.js';
import { IInstantiationService } from '../../../platform/instantiation/common/instantiation.js';
import { CodeActionMenu } from './codeActionMenu.js';
import { LightBulbWidget } from './lightBulbWidget.js';

var CodeActionUi = /*#__PURE__*/function (_Disposable) {
  _inherits(CodeActionUi, _Disposable);

  var _super = _createSuper(CodeActionUi);

  function CodeActionUi(_editor, quickFixActionId, preferredFixActionId, delegate, instantiationService) {
    var _this;

    _classCallCheck(this, CodeActionUi);

    _this = _super.call(this);
    _this._editor = _editor;
    _this.delegate = delegate;
    _this._activeCodeActions = _this._register(new MutableDisposable());
    _this._codeActionWidget = new Lazy(function () {
      return _this._register(instantiationService.createInstance(CodeActionMenu, _this._editor, {
        onSelectCodeAction: function onSelectCodeAction(action) {
          return __awaiter(_assertThisInitialized(_this), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    this.delegate.applyCodeAction(action,
                    /* retrigger */
                    true);

                  case 1:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, this);
          }));
        }
      }));
    });
    _this._lightBulbWidget = new Lazy(function () {
      var widget = _this._register(instantiationService.createInstance(LightBulbWidget, _this._editor, quickFixActionId, preferredFixActionId));

      _this._register(widget.onClick(function (e) {
        return _this.showCodeActionList(e.trigger, e.actions, e, {
          includeDisabledActions: false
        });
      }));

      return widget;
    });
    return _this;
  }

  _createClass(CodeActionUi, [{
    key: "update",
    value: function update(newState) {
      var _a, _b, _c;

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var actions, validActionToApply, invalidAction, includeDisabledActions;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(newState.type !== 1
                /* Triggered */
                )) {
                  _context2.next = 3;
                  break;
                }

                (_a = this._lightBulbWidget.rawValue) === null || _a === void 0 ? void 0 : _a.hide();
                return _context2.abrupt("return");

              case 3:
                _context2.prev = 3;
                _context2.next = 6;
                return newState.actions;

              case 6:
                actions = _context2.sent;
                _context2.next = 13;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](3);
                onUnexpectedError(_context2.t0);
                return _context2.abrupt("return");

              case 13:
                this._lightBulbWidget.getValue().update(actions, newState.trigger, newState.position);

                if (!(newState.trigger.type === 2
                /* Manual */
                )) {
                  _context2.next = 42;
                  break;
                }

                if (!((_b = newState.trigger.filter) === null || _b === void 0 ? void 0 : _b.include)) {
                  _context2.next = 31;
                  break;
                }

                // Triggered for specific scope
                // Check to see if we want to auto apply.
                validActionToApply = this.tryGetValidActionToApply(newState.trigger, actions);

                if (!validActionToApply) {
                  _context2.next = 25;
                  break;
                }

                _context2.prev = 18;
                _context2.next = 21;
                return this.delegate.applyCodeAction(validActionToApply, false);

              case 21:
                _context2.prev = 21;
                actions.dispose();
                return _context2.finish(21);

              case 24:
                return _context2.abrupt("return");

              case 25:
                if (!newState.trigger.context) {
                  _context2.next = 31;
                  break;
                }

                invalidAction = this.getInvalidActionThatWouldHaveBeenApplied(newState.trigger, actions);

                if (!(invalidAction && invalidAction.disabled)) {
                  _context2.next = 31;
                  break;
                }

                MessageController.get(this._editor).showMessage(invalidAction.disabled, newState.trigger.context.position);
                actions.dispose();
                return _context2.abrupt("return");

              case 31:
                includeDisabledActions = !!((_c = newState.trigger.filter) === null || _c === void 0 ? void 0 : _c.include);

                if (!newState.trigger.context) {
                  _context2.next = 38;
                  break;
                }

                if (!(!actions.allActions.length || !includeDisabledActions && !actions.validActions.length)) {
                  _context2.next = 38;
                  break;
                }

                MessageController.get(this._editor).showMessage(newState.trigger.context.notAvailableMessage, newState.trigger.context.position);
                this._activeCodeActions.value = actions;
                actions.dispose();
                return _context2.abrupt("return");

              case 38:
                this._activeCodeActions.value = actions;

                this._codeActionWidget.getValue().show(newState.trigger, actions, newState.position, {
                  includeDisabledActions: includeDisabledActions
                });

                _context2.next = 43;
                break;

              case 42:
                // auto magically triggered
                if (this._codeActionWidget.getValue().isVisible) {
                  // TODO: Figure out if we should update the showing menu?
                  actions.dispose();
                } else {
                  this._activeCodeActions.value = actions;
                }

              case 43:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 9], [18,, 21, 24]]);
      }));
    }
  }, {
    key: "getInvalidActionThatWouldHaveBeenApplied",
    value: function getInvalidActionThatWouldHaveBeenApplied(trigger, actions) {
      if (!actions.allActions.length) {
        return undefined;
      }

      if (trigger.autoApply === "first"
      /* First */
      && actions.validActions.length === 0 || trigger.autoApply === "ifSingle"
      /* IfSingle */
      && actions.allActions.length === 1) {
        return actions.allActions.find(function (action) {
          return action.disabled;
        });
      }

      return undefined;
    }
  }, {
    key: "tryGetValidActionToApply",
    value: function tryGetValidActionToApply(trigger, actions) {
      if (!actions.validActions.length) {
        return undefined;
      }

      if (trigger.autoApply === "first"
      /* First */
      && actions.validActions.length > 0 || trigger.autoApply === "ifSingle"
      /* IfSingle */
      && actions.validActions.length === 1) {
        return actions.validActions[0];
      }

      return undefined;
    }
  }, {
    key: "showCodeActionList",
    value: function showCodeActionList(trigger, actions, at, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this._codeActionWidget.getValue().show(trigger, actions, at, options);

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }]);

  return CodeActionUi;
}(Disposable);

CodeActionUi = __decorate([__param(4, IInstantiationService)], CodeActionUi);
export { CodeActionUi };